import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface EmptyStateProps {
  icon: ReactNode;
  message: string;
}

const EmptyState = ({ icon, message }: EmptyStateProps) => {
  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <Box sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }}>
        {icon}
      </Box>
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyState;
